import React from "react";
import http from '../modules/api';

import DatePicker from "react-datepicker";
import { is, ko } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";

import TextInput from "../modules/common/TextInput";
import SelectBoxV2 from '../modules/common/SelectBoxV2';
import Button from '../modules/common/Button';

import { PreviewRoot } from "./component/PreviewRoot";         
import PreviewTrigger from "./component/PreviewTrigger";
import { event } from "react-ga";

// 상품 자동설정 전용 옵션
const STATUS_OPTIONS = [
  { text: "전체 상태", value: "" },
  { text: "활성",     value: "Y" },
  { text: "중지",     value: "N" },
];

const TYPE_OPTIONS = [
  { text: "전체 유형", value: "" },
  { text: "싱글 피드",    value: "SINGLE" },
  { text: "슬라이드 피드",     value: "SLIDE" },
];

export default class InstagramAiImageAutomationList extends React.Component {
  static defaultProps = { pageSizes: [{value: 20, text: "20개"}, {value: 50, text: "50개"}, {value: 100, text: "100개"}] };

  constructor(props) {
    super(props);
    this.state = {
      posts: [],
      status: "",
      type: "",
      textMode: "",
      hashtagMode: "",
      publishType: "",
      startDate: null,
      endDate: null,
      page: 1,
      pageSize: 20,
      sortKey: "ias.reg_date",
      sortDir: "desc",
      selected: new Set(),
      total: 0,
    };
  }

  componentDidMount() {
    this.fetchPostsFromApi();
  }

  /**
   * API 호출: 상품 자동설정 목록
   * GET /shop/instagram/product-auto-settings/list
   * params: feed_type, product_select_logic?, text_mode?, hashtag_mode?, is_enabled, sort_by, sort_dir, start, row_cnt
   */
  fetchPostsFromApi = async () => {
    const {
      status,
      type,
      textMode,
      hashtagMode,
      publishType,
      startDate,
      endDate,
      page,
      pageSize,
      sortKey,
      sortDir
    } = this.state;

    const formatDate = (date) => {
      if (!date) return null;
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    try {
      const resp = await http.get("/rest/shop/instagram/auto/aiImage/setting/list", {
        params: {
          feed_type: type || "",
          text_mode: textMode || "",
          hashtag_mode: hashtagMode || "",
          publish_type: publishType || "",
          is_enabled: status || "",
          sort_by: sortKey || "ias.reg_date",
          sort_dir: (sortDir || "desc").toUpperCase(),
          start: (page - 1) * pageSize,
          row_cnt: pageSize,
          start_date: startDate ? formatDate(startDate) : null,
          end_date: endDate ? formatDate(endDate) : null,
        },
      });

      const { total, list } = resp.data;

      const posts = (list || []).map((m) => {
        const statusLabel = m.is_enabled === "Y" ? "활성" : "중지";

        return {
          id: String(m.instagram_ai_image_auto_setting_seq),
          setting_name: m.setting_name || "",
          type: m.feed_type || "-",
          slide_count: m.slide_count || "",
          image_ratio: m.image_ratio || "",
          is_enabled: m.is_enabled || "N",
          status: statusLabel,

          username: m.username || "",
          facebook_username: m.facebook_username || "",

          publish_cycle: m.publish_cycle || "",
          scheduled_time: m.scheduled_time || "",
          week_days: m.week_days || "",

          reg_date: m.reg_date || "",
          reg_date_format: m.reg_date_format || "",

          text_mode: m.text_mode || "",
          hashtag_mode: m.hashtag_mode || "",
          publish_type: m.publish_type || "",

          history_title: m.history_title || "",
          workflow_status: m.workflow_status || "",

          caption_count: Number(m.caption_count || 0),
          hashtag_count: Number(m.hashtag_count || 0),
          learned_feed_count: Number(m.learned_feed_count || 0),
          step_count: Number(m.step_count || 0),

          final_step_no: Number(m.final_step_no || 0),
          final_generated_image_url: m.final_generated_image_url || "",
          final_generated_thumbnail_url: m.final_generated_thumbnail_url || "",

          start_date: m.start_date || "",
          start_date_format: m.start_date_format || "",
          last_success_at: m.last_success_at || "",
          last_success_at_format: m.last_success_at_format || "",
        };
      });

      this.setState({
        posts,
        total: Number(total || 0),
      });
    } catch (err) {
      console.error("AI 이미지 자동설정 목록 조회 실패", err);
    }
  };

  // 유틸
  fmtNumber(n) { return (n === null || n === undefined) ? "-" : Number(n).toLocaleString(); }

  // 이벤트
  changeSort = (key) => {
    this.setState((prev) =>
      prev.sortKey === key
        ? { sortDir: prev.sortDir === "asc" ? "desc" : "asc" }
        : { sortKey: key, sortDir: "desc" }
    , this.fetchPostsFromApi);
  };
  handleInput = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value, page: 1 });
  };
  setQuickRange = (type) => {
    const today = new Date();
    if (type === "today") {
      this.setState({ startDate: today, endDate: today, page: 1 }, this.fetchPostsFromApi);
    } else if (type === "week") {
      const day = today.getDay();
      const diff = day === 0 ? 6 : day - 1;
      const monday = new Date(today); monday.setDate(today.getDate() - diff);
      const sunday = new Date(monday); sunday.setDate(monday.getDate() + 6);
      this.setState({ startDate: monday, endDate: sunday, page: 1 }, this.fetchPostsFromApi);
    } else if (type === "month") {
      const first = new Date(today.getFullYear(), today.getMonth(), 1);
      const last = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      this.setState({ startDate: first, endDate: last, page: 1 }, this.fetchPostsFromApi);
    } else {
      this.setState({ startDate: null, endDate: null, page: 1 }, this.fetchPostsFromApi);
    }
    this.setState({ dateType: type });
  };

  goPage = (p) => this.setState({ page: p }, this.fetchPostsFromApi);
  changePageSize = (e) => this.setState({ pageSize: Number(e.target.value), page: 1 }, this.fetchPostsFromApi);

  // 기존 TextInput과 SelectBoxV2를 그대로 사용하기 위해 래핑
  handleSelectBox = (name) => (text, value) => {
    this.handleInput({ target: { name, value } });
  };

  renderSortHead(label, key, align = "left", width = "auto") {
    const { sortKey, sortDir } = this.state;
    const active = sortKey === key;
    const arrow = active ? (sortDir === "asc" ? "▲" : "▼") : "";
    return (
      <th onClick={() => this.changeSort(key)} style={{ width, cursor: "pointer", textAlign: align }} title="정렬">
        {label} {/* arrow */}
      </th>
    );
  }

  // 활성/중지 토글 클릭
  // onClickToggleEnabled = async (e, settingSeq, stateKey, nextYN) => {
  //   e.stopPropagation();

  //   const prevYN = this.state[stateKey] ?? "Y"; // 기본 Y로 간주(초기엔 서버값 사용)
  //   // 낙관적 UI 업데이트
  //   this.setState({ [stateKey]: nextYN });

  //   try {
  //     // 예시1) POST 본문
  //     await http.post("/shop/instagram/product-auto-settings/enabled", {
  //       instagram_product_auto_setting_seq: settingSeq,
  //       is_enabled: nextYN,
  //     });
  //   } catch (err) {
  //     console.error("활성/중지 변경 실패", err);
  //     // 실패 → 롤백
  //     this.setState({ [stateKey]: prevYN });
  //     alert("변경에 실패했습니다. 잠시 후 다시 시도해주세요.");
  //   }
  // };

  renderScheduleCell = (m /* = row.__raw */) => {
    // 1) 주기 라벨 (네 패턴의 '일별' 자리에 매핑)
    const cycleLabel =
      m.publish_cycle === "DAILY" ? "매일" :
      m.publish_cycle === "WEEKLY" ? "매주" :
      m.publish_cycle === "BIDAY" ? "격일" :
      m.publish_cycle === "THREETIMES" ? "주 3회" :
      m.publish_cycle === "CUSTOM" ? "사용자 지정" :
      // publish_cycle만 있는 케이스 → 일별로 간주
      (m.publish_cycle != null ? "일별" : (m.publish_cycle || "일별"));


    const DAY_KO = ['일', '월', '화', '수', '목', '금', '토'];
    const toKoWeekdays = (m.week_days || '')
        .split(',')                   // ['0','1','2','3','']
        .map(s => s.trim())
        .filter(s => s !== '')        // 빈 값 제거 (트레일링 콤마 대응)
        .map(n => DAY_KO[Number(n)])  // 숫자 → 한글 요일
        .filter(Boolean)              // 유효하지 않은 인덱스 제거
        .join(', ');

    // 2) 월, 수,금... 마다
    // - publish_cycle 이 있으면 그대로 사용
    // - 없고 DAILY면 1일 마다로 표기하고 싶으면 아래 주석 해제
    const dayWeekly = (m.publish_cycle != null)
      ? `${toKoWeekdays} 마다`
      : null;

   // 3) 시간 표기: event_time 우선, 없으면 scheduled_time(HH:mm:ss) → HH시에
    const hourFromScheduled = m.scheduled_time
      ? m.scheduled_time.slice(0, 2)  // 앞 두 자리만 추출 (ex: "10:00:00" → "10")
      : null;

    const eventHour =
      m.event_time != null && m.event_time !== ""
        ? `${String(m.event_time).padStart(2, "0")}시에`
        : hourFromScheduled
        ? `${hourFromScheduled}시에`
        : null;

    // 4) 예약일
    const nextRun = m.next_auto_run_date ? `예약일 ${m.next_auto_run_date}` : null;

    return (
      <>
        <div>{cycleLabel}</div>
        {m.publish_cycle === "WEEKLY" && dayWeekly ? <div>{dayWeekly}</div> : null}
        {eventHour ? <div>{eventHour}</div> : null}
        {nextRun ? <div>{nextRun}</div> : null}
      </>
    );
  };

  // 활성/중지 토글 API 경로
  onClickToggleEnabled = async (e, settingSeq, stateKey, nextYN) => {
    e.stopPropagation();

    const prevYN = this.state[stateKey] ?? "Y";
    this.setState({ [stateKey]: nextYN });

    http.put(
      "/rest/shop/instagram/auto/aiImage/setting/isEnabled/update",
      null,
      {
        params: {
          instagram_ai_image_auto_setting_seq: settingSeq,
          is_enabled: nextYN,
        }
      }
    ).then(() => {
    }).catch((err) => {
      console.error("활성/중지 변경 실패", err);
      this.setState({ [stateKey]: prevYN });
      alert("변경에 실패했습니다. 잠시 후 다시 시도해주세요.");
    });
  };


  render() {
    const { pageSizes } = this.props;
    const { q, status, type, startDate, endDate, page, pageSize, selected, dateType } = this.state;
    const rows = this.state.posts;
    const total = this.state.total ?? rows.length;
    const totalPages = Math.max(1, Math.ceil(total / pageSize));
    const idsOnPage = rows.map((r) => r.id);
    const allChecked = idsOnPage.length > 0 && idsOnPage.every((id) => selected.has(id));

    return (
      <>
      <style>
        {
          `
            .data-table table {
              min-width: 1200px !important;
            }
            .data-table table th:nth-child(1)
            , .data-table table td:nth-child(1) {
              padding-left: 20px !important;
            }
          `
        }
      </style>
      // <PreviewRoot>
      <div id='page-wrapper' className="container eventFormPromotion" style={{backgroundColor: '#fafaf', minHeight:"100%"}}>
        <div id="posts" className="instagram-post-list page-section active">
          {/* 헤더 */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
            <h1 style={{ fontSize: 24, fontWeight: 600 }}>AI 피드 자동화 워크플로우 목록</h1>
            <Button
              type={"hover_mint"}
              width={"120px"}
              height={"38px"}
              fontSize={"1rem"}
              onClick={() => {window.location.href = "/shop/instagram/InstagramCreateAiImageAutomation";}}>
              ＋ 새 자동설정
            </Button>
          </div>

          {/* 필터 섹션 */}
          <div className="filter-section">
            <div className="filter-row">
              {/* <div style={{ flex: 1 }}>
                <TextInput
                  type="text"
                  id="search_q"
                  placeholder="🔍 설정명 검색 (서버 확장 시 사용)"
                  value={q}
                  onChange={(e, value) => this.setState({ q: value })}
                  width="100%"
                  height="36px"
                  onKeyDown={(e) => { if (e.key === 'Enter') { this.setState({ page: 1 }, this.fetchPostsFromApi); } }}
                />
              </div> */}
              <div style={{ flex:1 }}>
                <SelectBoxV2
                  id="statusSelect"
                  className="form-control"
                  pageWrapperName="common-page-wrapper"
                  width="100%"
                  height="36px"
                  padding="6px 30px 6px 10px"
                  list={STATUS_OPTIONS}
                  optionTexttName="text"
                  optionValuetName="value"
                  selectedValue={status}
                  placeHolder="전체 상태"
                  onClickOption={this.handleSelectBox("status")}
                  tabIndex={0}
                />
              </div>
              <div style={{ flex:1 }}>
                <SelectBoxV2
                  id="typeSelect"
                  className="form-control"
                  pageWrapperName="common-page-wrapper"
                  width="100%"
                  height="36px"
                  padding="6px 30px 6px 10px"
                  list={TYPE_OPTIONS}
                  optionTexttName="text"
                  optionValuetName="value"
                  selectedValue={type}
                  placeHolder="전체 유형"
                  onClickOption={this.handleSelectBox("type")}
                  tabIndex={0}
                />
              </div>

              <div className="robomd_date_picker flexBox" style={{ display: "flex", gap: 15, alignItems: "center", flexWrap: "nowrap", flex:1.8 }}>
                <div style={{ flex:1 }}>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => this.setState({ startDate: date, page: 1 })}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    maxDate={endDate || undefined}
                    dateFormat="yyyy.MM.dd"
                    locale={ko}
                    isClearable
                    placeholderText="시작일"
                    customInput={<input className="form-control" style={{ width: "100%" }} />}
                  />
                </div>
                <span style={{ color: "#8e8e8e" }}>~</span>
                <div style={{ flex:1 }}>
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => this.setState({ endDate: date, page: 1 })}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    minDate={startDate || undefined}
                    dateFormat="yyyy.MM.dd"
                    locale={ko}
                    isClearable
                    placeholderText="종료일"
                    customInput={<input className="form-control" style={{ width: "100%" }} />}
                  />
                </div>
              </div>

              <button className="btn btn-secondary" type="button" onClick={() => this.setState({ page: 1 }, this.fetchPostsFromApi)}>
                필터 적용
              </button>
            </div>

            <div className="filter-row">
              <div className="quick-filters">
                <button className={"quick-filter-btn" + (!dateType || dateType === "all" ? " active" : "")} onClick={() => this.setQuickRange("all")}>전체</button>
                <button className={"quick-filter-btn" + (dateType === "today" ? " active" : "")} onClick={() => this.setQuickRange("today")}>오늘</button>
                <button className={"quick-filter-btn" + (dateType === "week" ? " active" : "")} onClick={() => this.setQuickRange("week")}>이번 주</button>
                <button className={"quick-filter-btn" + (dateType === "month" ? " active" : "")} onClick={() => this.setQuickRange("month")}>이번 달</button>
              </div>
              <span style={{ marginLeft: "auto", fontSize: 14, color: "#8e8e8e" }}>
                총 {this.fmtNumber(total)}개
              </span>
            </div>
          </div>

          {/* 데이터 테이블 */}
          <div className="data-table">
            <table>
              <thead>
                <tr>
                  {this.renderSortHead("설정명", "ias.setting_name", "left", 160)}
                  <th style={{ width: 100, textAlign: "center" }}>계정</th>
                  <th style={{ width: 100, textAlign: "center" }}>피드 이미지 구성</th>
                  <th style={{ width: 80, textAlign: "center" }}>이미지 비율</th>
                  <th style={{ width: 140, textAlign: "center" }}>참조 워크플로우</th>
                  <th style={{ width: 100, textAlign: "center" }}>게시 방식</th>
                  <th style={{ width: 100, textAlign: "center" }}>문구 설정</th>
                  <th style={{ width: 100, textAlign: "center" }}>해시태그 설정</th>
                  <th style={{ width: 100, textAlign: "center" }}>자동 생성</th>
                  <th style={{ width: 120, textAlign: "center" }}>발행 주기</th>
                  {this.renderSortHead("설정 등록일", "ias.reg_date", "center", 120)}
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan={11} style={{ textAlign: "center", padding: 40, color: "#8e8e8e" }}>
                      조건에 맞는 자동설정이 없습니다.
                    </td>
                  </tr>
                ) : (
                  rows.map((row) => {
                    return (
                      <tr
                        key={row.id}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          window.location.href = `/shop/instagram/InstagramCreateAiImageAutomation?instagram_ai_image_auto_setting_seq=${row.id}`;
                        }}
                      >
                        <td style={{ textAlign: "left" }}>
                          <span>{row.setting_name || "-"}</span>
                        </td>

                        <td style={{ textAlign: "center" }}>
                          <span>
                            {(row.facebook_username || "-") + " / @" + (row.username || "-")}
                          </span>
                        </td>

                        <td style={{ textAlign: "center" }}>
                          <span className={"badge " + (row.type === "SLIDE" ? "badge-auto" : "badge-manual")}>
                            {row.type === "SLIDE"
                              ? `슬라이드 피드${row.slide_count ? ` (${row.slide_count}장)` : ""}`
                              : "싱글 피드"}
                          </span>
                        </td>

                        <td style={{ textAlign: "center" }}>
                          <span
                            className={
                              "badge " +
                              ((!row.image_ratio || row.image_ratio === "1:1")
                                ? "badge-auto"
                                : row.image_ratio === "4:5"
                                ? "badge-manual"
                                : row.image_ratio === "16:9"
                                ? "badge-published"
                                : "badge-failed")
                            }
                          >
                            {row.image_ratio || "1:1"}
                          </span>
                        </td>

                        <td style={{ textAlign: "center" }}>
                          <span className="badge badge-scheduled">
                            {row.history_title || "-"}
                          </span>
                          {/* {row.workflow_status ? (
                            <div style={{ fontSize: 11, color: "#8e8e8e", marginTop: 4 }}>
                              {row.workflow_status}
                            </div>
                          ) : null} */}
                        </td>

                        <td style={{ textAlign: "center" }}>
                          {row.publish_type === "PUBLISH" ? (
                            <span className="badge badge-published">발행</span>
                          ) : row.publish_type === "DRAFT" ? (
                            <span className="badge badge-manual">임시저장</span>
                          ) : (
                            <span className="badge badge-failed">-</span>
                          )}
                        </td>

                        <td style={{ textAlign: "center" }}>
                          {row.text_mode === "DIRECT" ? (
                            <span className="badge badge-manual">
                              직접 등록{row.caption_count > 0 ? ` (${row.caption_count})` : ""}
                            </span>
                          ) : row.text_mode === "AI" ? (
                            <span className="badge badge-auto">AI 자동 생성</span>
                          ) : row.text_mode === "LEARN" ? (
                            <span className="badge badge-scheduled">
                              내 피드 학습{row.learned_feed_count > 0 ? ` (${row.learned_feed_count})` : ""}
                            </span>
                          ) : (
                            <span className="badge badge-failed">-</span>
                          )}
                        </td>

                        <td style={{ textAlign: "center" }}>
                          {row.hashtag_mode === "BASIC" ? (
                            <span className="badge badge-manual">
                              기본 해시태그{row.hashtag_count > 0 ? ` (${row.hashtag_count})` : ""}
                            </span>
                          ) : row.hashtag_mode === "AI" ? (
                            <span className="badge badge-auto">AI 자동 생성</span>
                          ) : (
                            <span className="badge badge-failed">-</span>
                          )}
                        </td>

                        <td style={{ textAlign: "center" }}>
                          {(() => {
                            const seq = row.id;
                            const stateKey = "is_enabled_" + seq;
                            const curr = this.state[stateKey] == null ? row.is_enabled : this.state[stateKey];

                            if (curr === "Y") {
                              return (
                                <div
                                  className="non_connection_hide"
                                  style={{ margin: "0 auto", cursor: "pointer", width: 100 }}
                                  title="클릭하여 중지"
                                  onClick={(e) => this.onClickToggleEnabled(e, seq, stateKey, "N")}
                                >
                                  <p
                                    className="card-text btn_robomd_recomendation_back"
                                    style={{ width: "100px", height: "40px", position: "inherit" }}
                                  >
                                    <p
                                      className="card-text btn_robomd_recomendation_on_front"
                                      style={{
                                        width: "80px",
                                        height: "40px",
                                        lineHeight: "41px",
                                        position: "inherit",
                                        background: "#00e2e6",
                                        color: "#363636",
                                        fontSize: 12,
                                        fontWeight: "500",
                                      }}
                                    >
                                      자동 생성 중
                                    </p>
                                  </p>
                                </div>
                              );
                            }

                            return (
                              <div
                                className="non_connection_hide"
                                style={{ margin: "0 auto", cursor: "pointer", width: 100 }}
                                title="클릭하여 활성"
                                onClick={(e) => this.onClickToggleEnabled(e, seq, stateKey, "Y")}
                              >
                                <p
                                  className="card-text btn_robomd_recomendation_back"
                                  style={{ width: "100px", height: "40px", position: "inherit" }}
                                >
                                  <p
                                    className="card-text btn_robomd_recomendation_off_front"
                                    style={{
                                      width: "80px",
                                      height: "40px",
                                      lineHeight: "41px",
                                      position: "inherit",
                                      marginLeft: "22px",
                                      fontSize: 12,
                                      fontWeight: "500",
                                    }}
                                  >
                                    자동 생성 중지
                                  </p>
                                </p>
                              </div>
                            );
                          })()}
                        </td>

                        <td style={{ textAlign: "center", fontSize: 13 }}>
                          {this.renderScheduleCell(row)}
                        </td>

                        <td style={{ textAlign: "center", fontSize: 13 }}>
                          {row.reg_date_format || "-"}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          {/* 페이지네이션 */}
          <div className="pagination" style={{ position: "relative", overflow: "visible"}}>
            <div className="pagination-controls">
              <button className="page-btn" disabled={page <= 1} onClick={() => this.goPage(page - 1)}>◀</button>
              {Array.from({ length: Math.min(5, totalPages) }).map((_, i) => {
                const half = Math.floor(5 / 2);
                let start = Math.max(1, page - half);
                let end = Math.min(totalPages, start + 4);
                if (end - start < 4) start = Math.max(1, end - 4);
                const p = start + i;
                if (p > totalPages) return null;
                return (
                  <button key={p} className={"page-btn" + (p === page ? " active" : "")} onClick={() => this.goPage(p)}>
                    {p}
                  </button>
                );
              })}
              <button className="page-btn" disabled={page >= totalPages} onClick={() => this.goPage(page + 1)}>▶</button>
            </div>

            <div className={"pagination-cnt-controls"} style={{ display: "flex", gap: 10, alignItems: "center", position: "absolute", right: "20px" }}>
              <span style={{ fontSize: 14, color: "#8e8e8e" }}>페이지당</span>
              <SelectBoxV2
                id="pageSizeSelect"
                className="form-control"
                pageWrapperName="common-page-wrapper"
                width="120px"
                height="36px"
                padding="6px 30px 6px 10px"
                list={this.props.pageSizes}
                optionTexttName="text"
                optionValuetName="value"
                selectedValue={this.state.pageSize}
                placeHolder="페이지 크기"
                onClickOption={(text, value) => this.changePageSize({ target: { value } })}
                tabIndex={0}
              />
            </div>
          </div>
        </div>
      </div>
      // </PreviewRoot>
      </>
    );
  }
}